import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { safeReturnTo } from '../auth';

/**
 * react-oidc-context's AuthProvider handles the code exchange automatically
 * when the user lands on this route. We just wait, then send the user back to
 * the page that started the sign-in.
 */
export default function AuthCallback() {
  const auth = useAuth();
  if (auth.isLoading) return <p className="p-4 text-slate-500 dark:text-slate-400">Completing sign-in…</p>;
  if (auth.error) return <p className="p-4 text-red-600 dark:text-red-400">Sign-in error: {auth.error.message}</p>;
  return <Navigate to={safeReturnTo(auth.user?.state)} replace />;
}
